.state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 8px;
  padding: 40px 20px;
  color: var(--vc-text-muted);

  &.compact {
    padding: 20px;
  }

  .icon {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: var(--vc-gray-soft);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--vc-text-muted);
    margin-bottom: 4px;

    &.iconError {
      background: var(--vc-red-soft);
      color: var(--vc-red);
    }
  }

  .title {
    font-size: var(--vc-text-base);
    font-weight: var(--vc-weight-semibold);
    color: var(--vc-text);
  }

  .description {
    font-size: var(--vc-text-sm);
    max-width: 420px;
  }

  .actions {
    margin-top: 8px;
    display: flex;
    gap: 8px;
  }
}
